import { useContext, useRef, useState, useEffect } from "react";
import { AnyObject } from "react-final-form";

import { AppContext } from "../../../../lib/appContext";
import { LocalPersist, createLocalPersist, STORAGE_KEY } from "../../helpers/localPersist";
import get from "lodash/get";

interface Prefill
  extends Pick<
    LocalPersist<AnyObject>,
    Exclude<keyof LocalPersist<AnyObject>, "formSubscribe" | "clear" | "isPersisted">
  > {
  formSubscribe?: LocalPersist<AnyObject>["formSubscribe"];
  persisted: boolean;
}

interface PrefillOptions {
  noPrefill?: boolean;
}

const usePrefill = (options: PrefillOptions): Prefill => {
  const { noPrefill = false } = options;
  const { businessUnitConfig } = useContext(AppContext);
  const { businessCode } = businessUnitConfig;
  const enabled = get(businessUnitConfig, "quote.prefill", false);

  if (!enabled || noPrefill) {
    return { persisted: false, getValues: () => ({}), formSubscribe: undefined };
  }

  const [persisted, setPersisted] = useState<boolean>(false);
  const localPersist = useRef<LocalPersist<AnyObject>>();
  if (!localPersist.current) {
    localPersist.current = createLocalPersist({ name: `${STORAGE_KEY}-${businessCode}` });
  }
  const { isPersisted, getValues, formSubscribe } = localPersist.current;

  useEffect(() => {
    setPersisted(isPersisted());
  }, []);

  return { persisted, getValues, formSubscribe };
};

export { usePrefill };
